import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import { usePodcast } from "./PlayerContext";
import "./podcast.css";

export default function MiniPlayer() {
  const podcast = usePodcast();
  const navigate = useNavigate();
  const location = useLocation();
  const track = podcast.current;
  const visible = !!track && location.pathname !== "/podcast/now";

  useEffect(() => {
    document.querySelector(".App")?.classList.toggle("has-podcast-mini", visible);
    return () => document.querySelector(".App")?.classList.remove("has-podcast-mini");
  }, [visible]);

  if (!visible) return null;
  const art = track.posterUrl || track.albumCoverUrl;

  return (
    <div className="pod-mini">
      <button type="button" className="pod-mini__main" onClick={() => navigate("/podcast/now")}>
        {art ? <img src={art} alt="" /> : <span><Icon name="microphone" /></span>}
        <span>
          <strong>{track.title}</strong>
          <small>{track.mood} · Podcast</small>
        </span>
      </button>
      <button type="button" onClick={() => podcast.toggle().catch(() => {})} aria-label={podcast.playing ? "Pause" : "Play"}>
        <Icon name={podcast.playing ? "pause circle" : "play circle"} />
      </button>
      <button type="button" onClick={podcast.stop} aria-label="Stop">
        <Icon name="close" />
      </button>
    </div>
  );
}
